<template>
  <loading-icon v-if="loading" class="c-card c-card--claim-forms"></loading-icon>

  <div class="c-card c-card--claim-forms" v-else>
    <div class="c-card__header">
      <h2 class="c-card__title t-headline">{{ card.title }}</h2>
      <i class="c-card__header__icon fa fa-inbox t-headline"></i>
    </div>

    <div v-if="card.description" class="c-card--claim-forms__description"><p>{{ card.description }}</p></div>

    <transition name="fade" mode="out-in">
      <form-list
        v-if            = "openedForm === null"
        :title          = "card.title"
        :forms          = "formDetails"
        :submitted-form = "submittedForm">
      </form-list>

      <form-detail
        v-if        = "openedForm !== null"
        :forms      = "formDetails"
        :form-index = "openedForm">
      </form-detail>
    </transition>
  </div>
</template>




<script>
import { mapGetters } from 'vuex'
import FormList from '../forms/FormList'
import FormDetail from '../forms/FormDetail'

export default {
  components: {
    formList: FormList,
    formDetail: FormDetail
  },

  props: ['card'],
  data () {
    return {
      openedForm: null,
      submittedForm: null,
      toastWait: 12000
    }
  },

  computed: {
    ...mapGetters([
      'cards'
    ]),
    loading () {
      return !this.card.cardLoaded
    },
    formDetails () {
      return this.cards[this.card.id].forms.data
    }
  },

  mounted () {
    this.$on('open-form', (formIndex) => {
      this.openedForm = formIndex
      this.submittedForm = null
    })

    this.$on('submitted-form', () => {
      // show the success message
      this.submittedForm = this.openedForm
      this.openedForm = null
      setTimeout(() => {
        // hide the success message
        this.submittedForm = null
      }, this.toastWait)
    })

    this.$on('cancelled-form', () => {
      this.submittedForm = null
      this.openedForm = null
    })
  }
}
</script>


<style lang="sass" scoped>
  .fade-enter-active,
  .fade-leave-active
    transition: opacity .25s

  .fade-enter,
  .fade-leave-to
    opacity: 0
</style>



// WEBPACK FOOTER //
// ClaimForms.vue?151d7191